<template>
  <div ref="c_date_picker" class="date-picker">
    <div ref="container" class="calendar" @click.stop>
      <div v-if="danger.length > 0" class="danger-message">
        {{ danger }}
      </div>
      <div class="calendar-head" :class="{'danger': danger.length > 0}" @click="!text ? showBody = true : ''">
        <div class="title">
          <span v-if="confirmedDates.length === 0">
            Не выбрана
          </span>
          <span v-if="confirmedDates.length === 1">
            {{ confirmedDates[0]!== null ? $app.date.format(confirmedDates[0], 'date') : 'Нет даты' }}
          </span>
          <span v-if="confirmedDates.length === 2">
            {{ $app.date.format(confirmedDates[0], 'date') }} - {{ $app.date.format(confirmedDates[1], 'date') }}
          </span>
          <span v-if="confirmedDates.length > 2 && multidates">
            Выбрано дат: {{ confirmedDates.length }}
          </span>
        </div>
      </div>
      <div v-show="showBody" ref="popupCalendar" class="calendar-body" :class="{[positionClass]: true,}">
        <div class="selector">
          <div class="left-arrow" @click.stop="decrease">
            <img :src="arrowLeft" alt="">
          </div>
          <div class="title">
            <n-select small :data="selectMonths" :value.sync="selectedMonth" />
            <n-select small :data="selectYears" :value.sync="selectedYear" />
          </div>
          <div class="right-arrow" @click.stop="increase">
            <img :src="arrowRight" alt="">
          </div>
        </div>
        <div class="selectedDates">
          <div class="title">
            <span v-if="selectedDates.length === 1">
              {{ $app.date.format(selectedDates[0], 'date') }}
            </span>
            <span v-if="selectedDates.length === 2">
              {{ $app.date.format(selectedDates[0], 'date') }} - {{ $app.date.format(selectedDates[1], 'date') }}
            </span>
            <span v-if="selectedDates.length > 2 && multidates">
              Выбрано дат: {{ selectedDates.length }}
            </span>
          </div>
        </div>
        <div class="days-body">
          <div class="days">
            <div v-for="(weekDay, index) in defDays" :key="index" class="wrap-day">
              <div class="day">{{ weekDay }}</div>
            </div>
          </div>
          <div class="dates">
            <div v-for="(week, index) in calendar()" :key="index" class="date-row">
              <div class="date-wrap">
                <div
                  class="date" :class="{'selected': isSelected(week[1]),'between': isBetween(week[1]),
                                        'noDate': !week[1]?.numY, 'disabled': isDisabled(week[1]) }" @click="select(week[1])">
                  {{ week[1]?.index }}
                </div>
              </div>
              <div class="date-wrap">
                <div
                  class="date" :class=" {'selected': isSelected(week[2]),'between': isBetween(week[2]),
                                         'noDate': !week[2]?.numY, 'disabled': isDisabled(week[2])}" @click="select(week[2])">
                  {{ week[2]?.index }}
                </div>
              </div>
              <div class="date-wrap">
                <div
                  class="date" :class="{'selected': isSelected(week[3]),'between': isBetween(week[3]),
                                        'noDate': !week[3]?.numY, 'disabled': isDisabled(week[3])}" @click="select(week[3])">
                  {{ week[3]?.index }}
                </div>
              </div>
              <div class="date-wrap">
                <div
                  class="date" :class=" {'selected': isSelected(week[4]),'between': isBetween(week[4]),
                                         'noDate': !week[4]?.numY, 'disabled': isDisabled(week[4])}" @click="select(week[4])">
                  {{ week[4]?.index }}
                </div>
              </div>
              <div class="date-wrap">
                <div
                  class="date" :class="{'selected': isSelected(week[5]),'between': isBetween(week[5]),
                                        'noDate': !week[5]?.numY, 'disabled': isDisabled(week[5])}" @click="select(week[5])">
                  {{ week[5]?.index }}
                </div>
              </div>
              <div class="date-wrap">
                <div
                  class="date" :class="{'selected': isSelected(week[6]),'between': isBetween(week[6]),
                                        'noDate': !week[6]?.numY, 'disabled': isDisabled(week[6])}" @click="select(week[6])">
                  {{ week[6]?.index }}
                </div>
              </div>
              <div class="date-wrap">
                <div
                  class="date" :class="{'selected': isSelected(week[0]),'between': isBetween(week[0]),
                                        'noDate': !week[0]?.numY, 'disabled': isDisabled(week[0])}" @click="select(week[0])">
                  {{ week[0]?.index }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <n-button class="cancel" @click="clearDates">Отменить</n-button>
          <n-button class="submit" @click="submitDates">Сохранить</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import arrowLeft from 'assets/calendar/arrow-left.svg'
import arrowRight from 'assets/calendar/arrow-right.svg'

export default {
  name: 'CDatePicker',
  props: {
    requiredDate: {
      type: Boolean,
      default: true,
    },
    danger: {
      type: String,
      default: '',
    },
    text: {
      type: Boolean,
      default: false,
    },
    abledDatesPeriod: {
      type: Array,
      default: () => {
        return []
      },
    },
    sync: {
      type: Boolean,
      default: false,
    },
    period: {
      type: Boolean,
      default: false,
    },
    multidates: {
      type: Boolean,
      default: false,
    },
    preDate: {
      type: Array,
      default: () => {
        return [ new Date(), ]
      },
    },
  },
  data() {
    return {
      arrowLeft,
      arrowRight,
      year: null,
      days: [],
      defDays: [],
      rWeeks: [],
      rDays: [],
      months: [],
      showBody: true,
      localeDay: {
        ru: [ 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс', ],
        kz: [ 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сн', 'Жс', ],
      },
      localeMonths: {
        ru: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь', ],
        kz: [ 'Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан', ],
      },
      selectMonths: [
        { value: 0, title: 'Январь', },
        { value: 1, title: 'Февраль', },
        { value: 2, title: 'Март', },
        { value: 3, title: 'Апрель', },
        { value: 4, title: 'Май', },
        { value: 5, title: 'Июнь', },
        { value: 6, title: 'Июль', },
        { value: 7, title: 'Август', },
        { value: 8, title: 'Сентябрь', },
        { value: 9, title: 'Октябрь', },
        { value: 10, title: 'Ноябрь', },
        { value: 11, title: 'Декабрь', },
      ],
      selectYears: [
        { value: 2010, title: '2010', },
        { value: 2011, title: '2011', },
        { value: 2012, title: '2012', },
        { value: 2013, title: '2013', },
        { value: 2014, title: '2014', },
        { value: 2015, title: '2015', },
        { value: 2016, title: '2016', },
        { value: 2017, title: '2017', },
        { value: 2018, title: '2018', },
        { value: 2019, title: '2019', },
        { value: 2020, title: '2020', },
        { value: 2021, title: '2021', },
        { value: 2022, title: '2022', },
        { value: 2023, title: '2023', },
        { value: 2024, title: '2024', },
        { value: 2025, title: '2025', },
        { value: 2026, title: '2026', },
        { value: 2027, title: '2027', },
        { value: 2028, title: '2028', },
        { value: 2029, title: '2029', },
        { value: 2030, title: '2030', },
        { value: 2031, title: '2031', },
        { value: 2032, title: '2032', },
        { value: 2033, title: '2033', },
        { value: 2034, title: '2034', },
        { value: 2035, title: '2035', },
        { value: 2036, title: '2036', },
        { value: 2037, title: '2037', },
        { value: 2038, title: '2038', },
        { value: 2039, title: '2039', },
        { value: 2040, title: '2040', },
        { value: 2041, title: '2041', },
        { value: 2042, title: '2042', },
        { value: 2043, title: '2043', },
        { value: 2044, title: '2044', },
        { value: 2045, title: '2045', },
        { value: 2046, title: '2046', },
        { value: 2047, title: '2047', },
        { value: 2048, title: '2048', },
        { value: 2049, title: '2049', },
        { value: 2050, title: '2050', },
      ],
      positionClass: '',
      selectedMonth: {},
      selectedYear: {},
      selectedDates: [],
      confirmedDates: [],
      calendarDate: new Date(),
      calendarId: Math.random() + 'anchor',
      firstOpening: true,
    }
  },
  watch: {
    selectedMonth() {
      const month = this.selectedMonth?.value <= 9 ? '0' + this.selectedMonth?.value : this.selectedMonth?.value
      this.calendarDate = new Date(new Date(this.calendarDate.getFullYear(), month, this.calendarDate.getDate()))
    },
    selectedYear() {
      this.calendarDate = new Date(new Date(this.selectedYear?.value, this.calendarDate.getMonth(), this.calendarDate.getDate()))
    },
    showBody() {
      if (!this.showBody) {
        this.firstOpening = true
      }
      this.updatePosition()
    },
    date() {
      this.$emit('update:date', this.date)
      this.$emit('update:value', this.date)
      this.$emit('change', this.date)
    },
    preDate() {
      if (this.sync) {
        this.selectedDates = [ ...this.preDate, ]
        this.confirmedDates = [ ...this.preDate, ]
        this.calendarDate = new Date(this.confirmedDates[0].getFullYear(), this.confirmedDates[0].getMonth(), 1)
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  created() {
    if (this.requiredDate) {
      this.selectedDates = [ ...this.preDate, ]
      this.confirmedDates = [ ...this.preDate, ]
      this.calendarDate = new Date(this.confirmedDates[0].getFullYear(), this.confirmedDates[0].getMonth(), 1)
      this.submitDates()
    } else {
      this.showBody = false
      this.selectedDates = []
      this.confirmedDates = []
      this.calendarDate = new Date()
    }
    this.generateYears()
    this.init()
  },
  methods: {
    generateYears() {
      const start = 1940
      const end = new Date().getFullYear() + 20

      this.selectYears = Array.from(
        { length: end - start + 1, },
        (_, index) => ({ value: start + index, title: String(start + index), })
      )
    },
    handleClickOutside(event) {
      const popup = this.$refs.c_date_picker
      if (popup && !popup.contains(event.target)) {
        this.showBody = false
      }
    },
    updatePosition() {
      const popup = this.$refs.popupCalendar
      const trigger = this.$refs.container
      if (!popup || !trigger) return

      requestAnimationFrame(() => {
        const popupRect = popup.getBoundingClientRect()
        const triggerRect = trigger.getBoundingClientRect()

        if (!popupRect.height) {
          // иногда layout ещё не готов — попробуем через 1 кадр
          requestAnimationFrame(() => this.updatePosition())
          return
        }

        const spaceBelow = window.innerHeight - triggerRect.bottom
        const spaceAbove = triggerRect.top
        const spaceRight = window.innerWidth - triggerRect.right

        if (spaceBelow < popupRect.height && spaceAbove > popupRect.height) {
          this.positionClass = 'top'
        } else if (spaceBelow < popupRect.height && spaceRight > popupRect.width) {
          this.positionClass = 'right'
        } else {
          this.positionClass = ''
        }
      })
    },
    clearDates() {
      if (!this.requiredDate) {
        this.selectedDates = []
        this.confirmedDates = []
        this.$emit('update:date', this.period ? [] : null)
        this.$emit('update:value', this.period ? [] : null)
        this.$emit('change', this.period ? [] : null)
        this.showBody = false
        return
      }
      this.selectedDates = [ ...this.confirmedDates, ]
      this.showBody = false
    },
    submitDates() {
      if (!this.period && !this.multidates) {
        this.$emit('update:date', this.selectedDates[0])
        this.$emit('update:value', this.selectedDates[0])
        this.$emit('change', this.selectedDates[0])
        this.showBody = false
        this.confirmedDates = this.selectedDates
      } else {
        this.confirmedDates = this.selectedDates
        this.$emit('update:date', this.selectedDates)
        this.$emit('update:value', this.selectedDates)
        this.$emit('change', this.selectedDates)
        this.showBody = false
      }
    },
    init() {
      const lang = $app.store.getter('app.lang') || 'ru'
      this.months = this.localeMonths[lang]
      this.day = this.localeDay[lang]
      this.defDays = this.localeDay[lang]
      this.month = this.calendarDate.getMonth()
      this.year = this.calendarDate.getFullYear()
      this.selectedMonth = $n.filter(this.selectMonths, (e) => {
        if (e.value === this.month) {
          return e
        }
      })[0]
      this.selectedYear = $n.filter(this.selectYears, (e) => {
        if (e.value === this.year) {
          return e
        }
      })[0]
    },
    getNumberOfDay(today) {
      if (!today) return false
      const startOfYear = new Date(today.getFullYear(), 0, 0)
      const diff = today - startOfYear

      const oneDay = 1000 * 60 * 60 * 24
      return Math.floor((diff) / oneDay)
    },
    calendar() {
      let weeks = {}
      let week = 0
      let days = {}
      const dlast = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() + 1, 0).getDate()

      for (let i = 1; i <= dlast; i++) {
        days = {
          ...days,
          [new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), i).getDay()]: {
            index: i,
            numY: Number(this.getNumberOfDay(new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), i))),
            date: new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), i),
          },
        }
        if (new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), i).getDay() === 0) {
          weeks = {
            ...weeks,
            [week]: days,
          }
          week += 1
          days = {}
        }
      }
      if (Object.keys(days).length !== 0) {
        weeks = {
          ...weeks,
          [week]: days,
        }
      }

      return weeks
    },
    select(incomingDate) {
      if (this.isDisabled(incomingDate)) {
        return false
      }
      const date = incomingDate.date
      if (!this.firstOpening) {
        if (this.multidates) {
          let isExist = false
          $n.each(this.selectedDates, (e) => {
            if (e.toDateString() === date.toDateString()) {
              isExist = true
            }
          })

          if (isExist) {
            this.selectedDates = $n.filter(this.selectedDates, (e) => {
              if (e.toDateString() !== date.toDateString()) {
                return e
              }
            })
          } else {
            this.selectedDates.push(date)
          }
        } else {
          if (this.period) {
            if (this.selectedDates.length < 2) {
              this.selectedDates = [ ...this.selectedDates, date, ]
            } else {
              this.selectedDates = [ date, ]
            }

            if (this.selectedDates.length === 2) {
              const n1 = this.getNumberOfDay(this.selectedDates[0])
              const n2 = this.getNumberOfDay(this.selectedDates[1])

              const min = Math.min(n1, n2)

              const f = [ min === n1 ? this.selectedDates[0] : this.selectedDates[1], ]
              const s = [ min !== n1 ? this.selectedDates[0] : this.selectedDates[1], ]

              this.selectedDates = [ f[0], s[0], ]
            }
          } else {
            this.selectedDates = [ date, ]
          }
        }
      } else {
        this.firstOpening = false
        this.selectedDates = [ date, ]
      }
    },
    isSelected(date) {
      date = this.toDayStart(date?.date)
      if (this.multidates) {
        let isSelected = false
        $n.each(this.selectedDates, (e) => {
          if (this.toDayStart(e) === date) {
            isSelected = true
          }
        })
        return isSelected
      } else {
        if (!this.period) {
          return date === this.toDayStart(this.selectedDates[0])
        } else {
          return date === this.toDayStart(this.selectedDates[0]) || date === this.toDayStart(this.selectedDates[1])
        }
      }
    },
    isBetween(date) {
      if (!this.period) return false
      if (this.selectedDates.length <= 1) return false
      date = this.toDayStart(date?.date)
      const n1 = this.toDayStart(this.selectedDates[0])
      const n2 = this.toDayStart(this.selectedDates[1])

      const from = Math.min(n1, n2)
      const to = from === n1 ? n2 : n1

      return date >= from && date <= to
    },
    toDayStart(value) {
      let d
      if (value instanceof Date) {
        d = new Date(value.getTime())
      } else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [ y, m, day, ] = value.split('-').map(Number)
        d = new Date(y, m - 1, day)
      } else {
        d = new Date(value)
      }
      d.setHours(0, 0, 0, 0)
      return d.getTime()
    },
    isDisabled(date) {
      if (this.abledDatesPeriod.length === 0) return false

      const day = this.toDayStart(date?.date)
      const n1 = this.toDayStart(this.abledDatesPeriod[0])

      if (this.abledDatesPeriod.length === 1) {
        console.log(this.abledDatesPeriod, this.abledDatesPeriod.length)
        return day <= n1
      }

      const n2 = this.toDayStart(this.abledDatesPeriod[1])
      const from = Math.min(n1, n2)
      const to = Math.max(n1, n2)


      return day < from || day > to
    },
    decrease() {
      const date = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() - 1, 1)

      this.selectedMonth = $n.filter(this.selectMonths, (e) => {
        if (e.value === date.getMonth()) {
          return e
        }
      })[0]
      this.selectedYear = $n.filter(this.selectYears, (e) => {
        if (e.value === date.getFullYear()) {
          return e
        }
      })[0]
    },
    increase() {
      const date = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth() + 1, 1)

      this.selectedMonth = $n.filter(this.selectMonths, (e) => {
        if (e.value === date.getMonth()) {
          return e
        }
      })[0]
      this.selectedYear = $n.filter(this.selectYears, (e) => {
        if (e.value === date.getFullYear()) {
          return e
        }
      })[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.date-picker {


  .buttons {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    :deep() {
      .n-button {
        &.submit {
          margin-bottom: 5px;
          cursor: pointer;
          min-width: 180px;
          width: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 700;
          color: #FFFFFF;
          height: 48px;
          background-color: var(--primary);
          border-radius: 12px;
        }

        &.cancel {
          margin-bottom: 5px;
          cursor: pointer;
          width: auto;
          display: flex;
          min-width: 180px;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 700;
          color: var(--primary);
          height: 48px;
          background-color: #fff;
          border-radius: 12px;
          border: 1px solid var(--primary);
        }
      }
    }
  }

  .selectedDates {
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
      color: var(--primary);
      margin-bottom: 0;
    }
  }

  .danger-message {
    color: red;
  }

  .background-clicker {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 200;
  }

  .calendar {
    position: relative;
    z-index: 99;

    &-head {
      border: 1px solid var(--primary);
      min-width: 200px;
      height: 48px;
      display: flex;
      justify-content: center;
      padding: 0 30px;
      align-items: center;
      margin-left: 16px;
      color: var(--primary);

      :deep() {
        .n-select {
          .vs__selected {
            color: var(--primary);
          }
        }
      }

      &.danger {
        border: 2px solid red;
      }

      border-radius: 12px;

      .n-icon {
        padding: 0 10px;
        color: #000000;
      }

      .title {
        font-weight: 700;
        font-size: 16px;
        color: var(--primary);
        margin: 0;
        display: flex;
        align-items: center;
        cursor: pointer;

        :deep() {
          .n-select {
            cursor: pointer;

            .vs__dropdown-toggle {
              border: none;
            }

            .vs__dropdown-option {
              padding: 5px;
            }

            .vs__selected {
              margin: 4px 0 0;
              padding: 0;
            }

            .vs__dropdown-menu {
              &::-webkit-scrollbar {
                visibility: hidden;
              }
            }

            .vs.vs__selected-options {
              padding: 0;
            }

            .vs__search {
              width: 1px;
              height: 0;
              padding: 0;
            }

            .text-place {
              padding: 0;
            }
          }
        }
      }
    }

    &-body {
      z-index: 200;
      position: absolute;
      top: calc(100% + 20px);
      width: 422px;
      background: #FFF;
      box-shadow: 5px 5px rgba(138, 155, 203, 0.15);
      border-radius: 16px;
      padding: 20px;
      border: 2px solid rgba(116, 147, 232, 0.15);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      &.right {
        top: calc(-100% - 57px);
        left: calc(100% + 20px);
      }

      .selector {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .left-arrow, .right-arrow {
          img{
            height: 20px;
            object-fit: contain;
          }
        }

        :deep() {
          .n-select {
            height: auto;
            margin-top: 0;
            .vs__selected {
              color: var(--primary);
            }
          }
        }

        .n-icon {
          padding: 0 10px;
          color: #000000;
        }

        .title {
          font-weight: 700;
          font-size: 16px;
          color: var(--primary);
          margin: 0;
          display: flex;
          align-items: center;
          cursor: pointer;

          :deep() {
            .n-select {
              cursor: pointer;

              .vs__dropdown-toggle {
                border: none;
              }

              .vs__dropdown-option {
                padding: 5px;
              }

              .vs__selected {
                margin: 4px 0 0;
                padding: 0;
              }

              .vs__dropdown-menu {
                &::-webkit-scrollbar {
                  visibility: hidden;
                }
              }

              .vs.vs__selected-options {
                padding: 0;
              }

              .vs__search {
                width: 1px;
                height: 0;
                padding: 0;
              }

              .text-place {
                padding: 0;
              }
            }
          }
        }
      }

      .days-body {
        .month-title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #000000;
          font-weight: 500;
        }

        .days {
          display: flex;
          align-items: center;

          .day {
            font-weight: 700;
            font-size: 14px;
            width: 54px;
            height: 54px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--primary);

            &.selected {
              background-color: #2C117C1A;
            }
          }
        }

        .dates {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;

          .date-row {
            width: 100%;
            display: flex;
            align-items: center;

            &:first-child {
              .date-wrap {
                &:first-child {
                  .date {
                    border-radius: 12px 0 0 0;
                  }
                }

                &:last-child {
                  .date {
                    border-radius: 0 12px 0 0;
                  }
                }
              }
            }

            &:last-child {
              .date-wrap {
                &:first-child {
                  .date {
                    border-radius: 0 0 0 12px;
                  }
                }

                &:last-child {
                  .date {
                    border-radius: 0 0 12px 0;
                  }
                }
              }
            }
          }

          .date-wrap {
            .date {
              width: 54px;
              height: 54px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 14px;
              color: var(--primary);
              border: 1px solid #D5D4DF;

              &.inactive {
                background-color: #777676;
                color: #777676;
              }

              &.between {
                background-color: #E7EDFF;
              }

              &.noDate {
                background-color: #E7EDFF;
                color: #B1B1B1;
              }

              &.selected {
                background-color: var(--primary);
                color: #ffffff;
                font-weight: bold;
              }

              &.disabled {
                background-color: #2C117C1A;
              }
            }
          }
        }
      }
    }
  }
}
</style>
